import NewsDetailsModal from "components/layout/NewsDetailsModal";
import { TextEllipsis } from "components/shared";
import { Button, Tooltip } from "components/ui";
import { ModalContext } from "contexts/ModalContext";
import { PriorityModalContext } from "contexts/PriorityModalContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { HiCheckCircle, HiExternalLink, HiOutlineCheck, HiOutlineCheckCircle, HiOutlineChip, HiOutlineExternalLink, HiOutlineEye } from "react-icons/hi";
import { HiOutlineCpuChip } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

const TrendingNewsItem = ({ 
    news, 
    height = 175, 
    isListView = false, 
    isSelect = false, 
    onSelect = undefined, 
    onUnselect = undefined, 
    selected = false, 
    hasDescription = true,
    className = ""
}) => {
    
    const { openModalPriority } = useContext(PriorityModalContext);
    const navigate = useNavigate();

    const handleOnClick = () => {
        if (isSelect) {
            if (selected) { 
                onUnselect();
            } else {
                onSelect();
            }
        }
    }
    

    return (
        <div onClick={handleOnClick} className={`inline-block w-full rounded-2xl overflow-hidden relative shadow ${isSelect && `cursor-pointer`} ${selected && `outline outline-[2px] outline-primary-600 shadow-lg`} ${selected && !isListView && `opacity-[0.4]`} ${className}`}>
            <div className="overflow-hidden">
                <div className="relative overflow-hidden">
                    <img onError={(e) => e.target.src = "/img/others/auth-cover-bg.jpg"} src={news?.urlToImage ? news?.urlToImage : "/img/others/auth-cover-bg.jpg"} className={`object-cover !w-full`} style={{ height: isListView ? `100px` : `${height}px`}} />
                    <div className="top-0 left-0 w-full h-full absolute bg-gradient-to-t from-transparent via-transparent to-gray-900/80 flex justify-end items-start px-4 py-4 gap-1">
                        {isSelect && !selected && <HiOutlineCheckCircle className={`text-2xl text-white drop-shadow opacity-[0.6] drop-shadow ${isListView ? `right-4 top-4` : `left-4 top-4`} ${selected && `text-primary-600 opacity-[1]`}`} />}
                        {isSelect && selected && <HiCheckCircle className={`text-2xl text-white drop-shadow opacity-[0.6] drop-shadow ${isListView ? `right-4 top-4` : `left-4 top-4`} ${selected && `text-primary-600 opacity-[1]`}`} />}
                    </div>
                </div>
                <div className="p-4 pb-2 flex flex-col justify-between gap-1">
                    <span className="flex-1 font-semibold !text-tertiary-900 dark:!text-gray-50 text-sm line-clamp-2 min-h-[40px]">{news?.title}</span>
                    {hasDescription && <span className="flex-1 font-normal !text-tertiary-700 dark:!text-gray-50 text-xs line-clamp-3 h-auto mt-2">{news?.description}</span>}
                    <div className="flex-1 flex gap-2 justify-between items-center">
                        <span className="text-tertiary-400"><TextEllipsis text={news?.source?.name} maxTextCount={20} /></span>
                        {!isListView && 
                            <div className="flex">
                                <Tooltip title="Link">
                                    <Button onClick={(e) => { e.stopPropagation(); window.open(news?.url); }} variant="plain" shape="circle" className="!text-tertiary-800 dark:!text-white !bg-transparent hover:!bg-tertiary-100/20" icon={<HiOutlineExternalLink />} />
                                </Tooltip>
                                <Tooltip title="View more">
                                    <Button onClick={(e) => { e.stopPropagation(); openModalPriority(<NewsDetailsModal news={news} />, 712); }} variant="plain" shape="circle" className="!text-tertiary-800 dark:!text-white !bg-transparent hover:!bg-tertiary-100/20" icon={<HiOutlineEye />} />
                                </Tooltip>
                                {!isSelect && <Tooltip title="Generate from news">
                                    <Button 
                                        onClick={() => navigate(`/playground`, { state: { template: 'news', home_item: news } })}
                                        variant="plain" 
                                        shape="circle" 
                                        className="!text-primary-600 !bg-transparent hover:!bg-gray-100/20" 
                                        icon={<HiOutlineCpuChip />} 
                                    />
                                </Tooltip>}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrendingNewsItem;